import { Divider } from "@mui/material";
import { SWITCH_TAB_TYPE, SwitchTabs } from "../../../common/SwitchTabs";
import { GroupChatListPanelHeader } from "../../GroupChatListPanelHeader";
import { GroupChatListPanelHeaderWrapper } from "./PatientChats.styles";
import PatientGroupChatList from "./PatientGroupChatList";
import { PatientChatsContext } from "hhn-commons";
import { useContext } from "react";
import { CHAT_DETAILS } from "./PatientChats";

type PatientChatListPanelProps = {
  unreadChatCount: number;
  selectedChatId?: string;
  chatItemView: CHAT_DETAILS;
  setChatItemView: (view: CHAT_DETAILS) => void;
};

export const PatientChatListPanel = ({
  unreadChatCount,
  selectedChatId,
  chatItemView,
  setChatItemView,
}: PatientChatListPanelProps) => {
  const { chatData, fetchChats, isChatLoading } =
    useContext(PatientChatsContext);

  return (
    <>
      <Divider />
      <GroupChatListPanelHeaderWrapper>
        <GroupChatListPanelHeader
          unreadChatCount={unreadChatCount}
          searchResultCount={chatData?.searchMatchCount}
          listSize={(chatData?.chats || []).length}
        />

        <SwitchTabs
          type={SWITCH_TAB_TYPE.MESSAGES}
          onTabValueChange={setChatItemView}
        />
      </GroupChatListPanelHeaderWrapper>
      <Divider />
      <PatientGroupChatList
        chats={chatData?.chats || []}
        selectedChatId={selectedChatId}
        isChatLoading={isChatLoading}
        fetchChatList={fetchChats}
        showChatDetails={chatItemView}
        isMoreChats={chatData?.hasNext}
      />
    </>
  );
};
